import {observable, action, runInAction} from 'mobx'
import {get, json} from '../../../../utils/ajax'
import {setStore} from "../../../../utils/Utils";
import {message} from 'antd'

class manualContentStore {

    @observable loading
    @observable carseriesList //接收查出的车系列表
    @observable expandedLeftRowKeys //展开左侧目录树
    @observable tree //左侧目录树
    @observable pdfContents //右边展示pdf内容
    @observable catalogId //目录ID
    @observable selectLeftRowId //点击左侧目录树id
    @observable contentId //内容id
    @observable fileName //文件名称
    @observable uploadAddressId //下载地址

    constructor() {
        this.loading = false
        this.carseriesList = []
        this.expandedLeftRowKeys = []
        this.tree = []
        this.pdfContents = []
        this.catalogId = ''
        this.selectLeftRowId = ''
        this.contentId = ''
        this.fileName = ''
        this.uploadAddressId = ''
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 首页选择车系下拉框
     * @returns {Promise.<void>}
     */
    @action
    initCarseries = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCarseriesCatalog/carSeriesUnderPullFrame`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.carseriesList = res || []
            this.loading = false
        })
    }

    /**
     * 根据车系id查询目录树
     */
    @action
    initEditPageCarseries = async (value) => {
        if (!value) {
            this.tree = []
            this.catalogId = ''
        }
        runInAction(() => {
            this.loading = true
            this.pdfContents=[]
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualCatalog/queryListByCarCode?carseriesId=${value}`)
        if (res && res.status === 0){
            this.loading = false
            return;
        }
        if (res.length === 0) {
            message.warning('该车系暂无目录！')
            runInAction(() => {
                this.tree = [];
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.tree = res
            this.loading = false
        })
    }

    /**
     * 展开左侧目录树
     */
    @action
    changeExpandedLeftRowKeys = (expandedRows) => {
        this.expandedLeftRowKeys = expandedRows
    }

    /**
     * 通过目录id获得信息
     */
    @action
    getInformationByDirectoryId = async (record) => {
        runInAction(() => {
            this.loading = true
            this.catalogId = record.id
            this.selectLeftRowId = record.id
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualDocumentContent/queryByDirectoryId/${record.id}`)
        if (res && res.status === 0){
            this.pdfContents = []
            this.loading = false
            return;
        }
        runInAction(() => {
            this.pdfContents = [res]
            this.contentId = res.id
            this.uploadAddressId=res.uploadAddress
            this.fileName = res.name
            this.loading = false
        })
    }

    /**
     * 新增PDF
     */
    @action
    savePDF=async (file)=>{
        this.loading=true
        let data = {
            catalogId:this.catalogId,
            uploadAddress:file.file.response,
            name:file.file.name,
        }
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualDocumentContent/addFile`,data)
        runInAction(()=>{
            this.loading=false
            if(res.status){
                message.success('上传成功')
            }
            this.getInformationByDirectoryId2(this.catalogId)
        })
    }

    /**
     * 通过目录id获得信息
     */
    @action
    getInformationByDirectoryId2 = async (catalogId) => {
        runInAction(() => {
            this.loading = true
            this.catalogId = catalogId
            this.selectLeftRowId = catalogId
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualDocumentContent/queryByDirectoryId/${catalogId}`)
        runInAction(() => {
            this.pdfContents = [res]
            this.contentId = res.id
            this.fileName = res.name
            this.loading = false
        })
    }

    /**删除pdf**/
    @action
    removePDF=async (id)=>{
        const res=await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/manualDocumentContent/deleteById?id=${id}`)
        runInAction(() => {
            if(res.status){
                message.success(`删除成功！`)
            }
            this.pdfContents = []
        })
    }

}
export default new manualContentStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/manual/manualContent/store.js